import { useEffect, useState } from "react";
import api from "../services/api";
import "../styles/pos.css";

const Products = () => {
  const user = JSON.parse(localStorage.getItem("user"));
  const isAdmin = ["ADMIN", "SUPER_ADMIN", "MANAGER"].includes(user.role);

  const [products, setProducts] = useState([]);
  const [showForm, setShowForm] = useState(false);

  const [form, setForm] = useState({
    name: "",
    barcode: "",
    hsn: "",
    gst_percent: "",
    price: ""
  });

  const loadProducts = async () => {
    const res = await api.get("/products");
    setProducts(res.data || []);
  };

  useEffect(() => {
    loadProducts();
  }, []);

  const handleChange = e => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const addProduct = async () => {
    if (!form.name || !form.price || !form.seller_name) {
      alert("Product name and price required");
      return;
    }

    try {
      await api.post("/products", {
        ...form,
        gst_percent: Number(form.gst_percent) || 0,
        price: Number(form.price)
      });

      setForm({
        name: "",
        barcode: "",
        hsn: "",
        gst_percent: "",
        price: "",
        seller_name: ""
      });

      setShowForm(false);
      loadProducts();
    } catch (err) {
      alert(err.response?.data?.error || "Failed to add product");
    }
  };

  return (
    <div className="page-container">
      {/* ===== HEADER ===== */}
      <div className="page-header">
        <h2>Products</h2>

        {isAdmin && (
          <button
            className="primary-btn"
            onClick={() => setShowForm(!showForm)}
          >
            ➕ Add Product
          </button>
        )}
      </div>

      {/* ===== ADD PRODUCT FORM (ADMIN ONLY) ===== */}
      {isAdmin && showForm && (
        <div className="card">
          <h4>Add New Product</h4>

          <div className="form-row">
            <input
              name="name"
              placeholder="Product Name"
              value={form.name}
              onChange={handleChange}
            />
            <input
    name="seller_name"
    placeholder="Seller Name"
    value={form.seller_name}
    onChange={handleChange}
  />
            <input
              name="barcode"
              placeholder="Barcode"
              value={form.barcode}
              onChange={handleChange}
            />
          </div>

          <div className="form-row">
            <input
              name="hsn"
              placeholder="HSN Code"
              value={form.hsn}
              onChange={handleChange}
            />
            <input
              name="gst_percent"
              type="number"
              placeholder="GST %"
              value={form.gst_percent}
              onChange={handleChange}
            />
            <input
              name="price"
              type="number"
              placeholder="Price"
              value={form.price}
              onChange={handleChange}
            />
          </div>

          <button className="primary-btn" onClick={addProduct}>
            Save Product
          </button>
        </div>
      )}

      {/* ===== PRODUCT LIST ===== */}
      <div className="invoice-table print-container">
        <table>
          <thead>
            <tr>
              <th>Product Name</th>
              <th>Seller</th>
              <th>Barcode</th>
              <th>HSN</th>
              <th>GST %</th>
              <th>Price</th>
              <th>Status</th>
            </tr>
          </thead>
          <tbody>
            {products.map(p => (
              <tr key={p.product_id}>
                <td><b>{p.name}</b></td>
                <td>{p.seller_name}</td>
                <td>{p.barcode || "-"}</td>
                <td>{p.hsn || "-"}</td>
                <td>{p.gst_percent}%</td>
                <td>₹{p.price}</td>
                <td>
                  <span
                    className={`badge ${
                      p.is_active ? "active" : "inactive"
                    }`}
                  >
                    {p.is_active ? "Active" : "Disabled"}
                  </span>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default Products;
